import React, { useState } from "react";
import { Button, Dropdown, Menu, Select, Space } from "antd";
import type { MenuInfo } from "rc-menu/lib/interface";
import invariant from "ts-invariant";
import { PersonalizationValue } from "@dots-projects/types";
import ReactQuill, { Quill, Range } from "react-quill";
const Delta = Quill.import("delta");

type Props = {
  insertVariables: PersonalizationValue[]; // Check PersonalizationValue.ts definition
  readOnly?: boolean;
  quillEditorRef: {
    current: (ReactQuill & { cursorPos: Range }) | null;
  };
};

function InsertEditorVariables(props: Props) {
  const [placeHolderText] = useState("{} Insert variable");

  const onClick = (option: MenuInfo) => {
    const insertVariableSelected = props.insertVariables.find(
      (item: PersonalizationValue) => item.id === option.key
    );

    invariant(props.quillEditorRef.current, "Quill editor ref is null");
    invariant(insertVariableSelected, "Insert variable not found");

    const quill = props.quillEditorRef.current;

    const quillEditor = quill.getEditor();
    const cursorPos = quill.cursorPos;

    const insertVariableDelta = {
      mention: {
        index: "0",
        id: insertVariableSelected.id,
        denotationChar: "{{",
        value: insertVariableSelected.value,
      },
    };

    /**
     * Insert the variable (text) at the current cursor position.
     */
    const currentDeltas = quillEditor.getContents();
    if (cursorPos) {
      const currentPos = cursorPos.index;
      // We sum 1 to the current position because we want cursor to be after the insert variable
      const newCursorPos = cursorPos.index + 1;
      quillEditor
        .updateContents(
          new Delta().retain(currentPos).insert(insertVariableDelta),
          "user"
        )
        .concat(currentDeltas)
        .delete(newCursorPos);
    } else {
      //Append to the end of the editor
      quillEditor.setContents(
        currentDeltas.concat(new Delta().insert(insertVariableDelta)),
        "user"
      );
    }
  };

  const menu = (
    <Menu>
      {props.insertVariables.map((insertVariable) => (
        <Menu.Item key={insertVariable.id} onClick={onClick}>
          {insertVariable.userText || insertVariable.value}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="mt-4">
      <Dropdown overlay={menu} placement={"topRight"} disabled={props.readOnly}>
        <Button>
          <Space>{placeHolderText}</Space>
        </Button>
      </Dropdown>
    </div>
  );
}

export default InsertEditorVariables;
